import { useContext } from 'react';
import Col from 'react-bootstrap/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../../../LanguageContext';

const Aboutleft = ({ activeIndex, handleToggle }) => {
    const {language, setLanguage} = useContext(LanguageContext);
    return (

        <Tab.Container id="list-group-tabs-example " defaultActiveKey="#link1">
            <Row>
                <Col sm={12}>

                    <ListGroup className='c-lineheight3'>
                            {/* Other ListGroup.Item elements */}

                            <ListGroup.Item
                                as={Link}
                                action
                                to="/aboutus"
                                className={`px-3 ${activeIndex === 0 ? " active" : ""}`}
                                title="aboutus"
                                onClick={() => handleToggle(0)} // Assuming this ListGroup.Item corresponds to index 1
                            >
                                <i className="fas fa-chevron-circle-right me-3"></i>
                                {language==='en'?'About Us':'हमारे बारे में'}
                            </ListGroup.Item>

                            <ListGroup.Item
                                as={Link}
                                action
                                to="/vision"
                                className={`px-3 ${activeIndex === 1 ? " active" : ""}`}
                                title="Vision"
                                onClick={() => handleToggle(1)} // Assuming this ListGroup.Item corresponds to index 1
                            >
                                <i className="fas fa-chevron-circle-right me-3"></i>
                                {language==='en'?'Vision':'ध्येय'}
                            </ListGroup.Item>

                        <ListGroup.Item
                            as={Link}
                            action
                            to="/mission"
                            className={`px-3 ${activeIndex === 2 ? " active" : ""}`}
                            title="Mission"
                            onClick={() => handleToggle(2)} // Assuming this ListGroup.Item corresponds to index 1
                        >
                            <i className="fas fa-chevron-circle-right me-3"></i>
                           {language==='en'?'Mission':'लक्ष्य'}
                        </ListGroup.Item>

                        <ListGroup.Item
                            as={Link}
                            action
                            to="/Objectives"
                            className={`px-3 ${activeIndex === 3 ? " active" : ""}`}
                            title="Objectives"
                            onClick={() => handleToggle(3)} // Assuming this ListGroup.Item corresponds to index 1
                        >
                            <i className="fas fa-chevron-circle-right me-3"></i>
                           {language==='en'?'Objectives':'उद्देश्य'}
                        </ListGroup.Item>

                            <ListGroup.Item
                                as={Link}
                                action
                                to="/NIRF"
                                className={`px-3 ${activeIndex === 4 ? " active" : ""}`}
                                title="NIRF"
                                onClick={() => handleToggle(4)}
                            >
                                <i className="fas fa-chevron-circle-right me-3"></i>
                                {language==='en'?'NIRF':'एनआईआरएफ'}
                            </ListGroup.Item>
                            {/* Other ListGroup.Item elements */}
                        </ListGroup>

        

                    </Col>
            </Row>
        </Tab.Container>
    );
};

export default Aboutleft;



// function Main({ activeIndex }) {
//     return (
//         <Tab.Container id="list-group-tabs-example " defaultActiveKey="#link1">
//             <Row>
//                 <Col sm={12}>
//                     <ListGroup className='c-lineheight3'>
//                         <b className='text-danger fs-5'>Undergraduate</b>
//                         <ListGroup.Item as={Link} action to="/aboutus" className={`px-3 ${activeIndex === 0 ? " active" : ""}`}>
//                             <i className="fas fa-chevron-circle-right me-3"></i>
//                             About US
//                         </ListGroup.Item>

//                         <ListGroup.Item as={Link} action to="/mission-vision" className={`px-3 ${activeIndex === 1 ? " active" : ""}`} title="Mission | Vision"  >
//                             <i className="fas fa-chevron-circle-right me-3"></i>
//                             Vision & Mission
//                         </ListGroup.Item>
                       
//                         <ListGroup.Item as={Link} action to="/dual-degree-curriculum" className={`px-3 ${activeIndex === 2 ? " active" : ""}`}>
//                             <i className="fas fa-chevron-circle-right me-3"></i>
//                             NIRF
//                         </ListGroup.Item>
                       
                       
                 

//                     </ListGroup>
//                 </Col>   
//             </Row>
//         </Tab.Container>
//     );
// }

// export default Main;